import type { InternalRequest } from '../client.js';
import type { Session } from '@trackizy/types';

export function authEndpoints(req: InternalRequest) {
  return {
    login: (email: string, password: string) =>
      req.request<Session>('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      }),
    register: (email: string, password: string, name: string) =>
      req.request<Session>('/auth/register', {
        method: 'POST',
        body: JSON.stringify({ email, password, name }),
      }),
    session: () => req.request<Session>('/auth/session'),
    // Trackizy Staff phone-OTP onboarding (Plan 1).
    // Server: POST /api/auth/staff/request-otp + /verify-otp.
    requestStaffOtp: (phone: string) =>
      req.request<{ ok: boolean }>('/auth/staff/request-otp', {
        method: 'POST',
        body: JSON.stringify({ phone }),
      }),
    verifyStaffOtp: (phone: string, code: string) =>
      req.request<Session>('/auth/staff/verify-otp', {
        method: 'POST',
        body: JSON.stringify({ phone, code }),
      }),
    logout: async () => {
      // Send the DELETE FIRST: request() reads the token from storage at call
      // time, and the server revokes the JWT only when the request carries it
      // (audit N3, 2026-10-14 — clearing storage first made every logout an
      // anonymous DELETE that revoked nothing). Storage is cleared in
      // `finally` so a network failure or 5xx never leaves a token behind;
      // logout stays best-effort and never throws.
      try {
        await req.request<void>('/auth/session', { method: 'DELETE' });
      } catch {
        /* ignore — logout is best-effort */
      } finally {
        await Promise.resolve(req.getStorage().set(null));
      }
    },
  };
}
